/** Default access JWT lifetime when "Stay signed in" is off. */
export const DEFAULT_JWT_ACCESS_EXPIRY = "375h";
/** Default access JWT lifetime when "Stay signed in" is on. */
export const DEFAULT_JWT_REMEMBER_ME_EXPIRY = "30d";

/**
 * Resolve JWT `exp` duration string for jose `setExpirationTime`.
 * Values come from env so ops can tune without code changes.
 */
export function resolveAuthJwtExpiry(rememberMe: boolean): string {
  const access = process.env.JWT_ACCESS_EXPIRY?.trim() || DEFAULT_JWT_ACCESS_EXPIRY;
  const remember =
    process.env.JWT_REMEMBER_ME_EXPIRY?.trim() || DEFAULT_JWT_REMEMBER_ME_EXPIRY;
  return rememberMe ? remember : access;
}
